import { lazy } from 'react'

export const AgeRangeVariant2 = lazy(() => import('./v2/AgeRangeVariant2'))
export const AgeRangeVariant3 = lazy(() => import('./v3/AgeRangeVariant3'))
